import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import { showNotification } from '../../action/NotificationAction';
import { getSubjectReferralSummary } from '../../action/Admin/CommonAction';
import { PATH } from '../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import AppConfig from '../../../utils/common/DomainConfiguration';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class EducatorSubjectReferralSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            isLoading: false,
            visitInfoList: [],
        };
    }

    //componentDidMount
    componentDidMount() {
        const { id } = this.props.match.params;
        this.invokeVisitInfoList(id, true);
    }

    //toggleLoading
    toggleLoading() {
        this.setState({ isLoading: !this.state.isLoading }, () => {});
    }

    //invokeVisitInfoList
    invokeVisitInfoList(id) {
        this.toggleLoading();
        this.props.getSubjectReferralSummary(id, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    visitInfoList: response.response,
                });
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
            }
            this.toggleLoading();
        });
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    /**
     * Render page
     */
    render() {
        const { visitInfoList } = this.state;
        return (
            <div className="flex w-full h-full fixed left-0 top-0">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.APPOINTMENT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-grow flex-col">
                    <Headers
                        {...this.props}
                        title="Session Summary"
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="h-full w-full flex-col flex overflow-auto py-8 bg-UIBackground">
                        <div className="sm:flex justify-between sm:px-8 px-4 items-center">
                            <h6 className="m-0 text-lg text-white font-semibold">
                                Element Summary
                            </h6>
                        </div>

                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="flex flex-row flex-grow sm:px-8 px-4 mt-6">
                                    <div className="w-full flex flex-col p-6 border-black-10 bg-card rounded-lg">
                                        <div className="w-full">
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 items-center">
                                                <h6 className="text-white font-medium">
                                                    Referred by Owner
                                                </h6>
                                                <h6
                                                    className="text-white"
                                                    title={visitInfoList.referredByEducatorName}
                                                >
                                                    {visitInfoList.referredByEducatorName}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="text-white font-medium">{AppConfig.labels.channelName}</h6>

                                                <h6
                                                    className="text-white"
                                                    title={visitInfoList.subjectName}
                                                >
                                                    {visitInfoList.subjectName}
                                                </h6>
                                            </div>
                                            <div className="pb-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <h6 className="text-white font-medium">
                                                    Element
                                                </h6>
                                                <h6 className="text-white">
                                                    {visitInfoList.subcategoryName}
                                                </h6>
                                            </div>
                                            <div className="flex justify-end sm:mt-80">
                                                <p className="text-muted">
                                                    Created Time :{' '}
                                                    {moment(visitInfoList.createdAt).format(
                                                        'MMM DD, YYYY hh:mm A'
                                                    )}{' '}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getSubjectReferralSummary: (visitId, callBack) => {
            dispatch(getSubjectReferralSummary(visitId, callBack));
        },
    };
};

export default connect(null, mapDispatchToProps)(EducatorSubjectReferralSummary);
